import { makeStyles } from "@material-ui/core";
import { Colors } from "styles/Colors";

const HEADER_HEIGHT = 48;
const HAIRLINE = Colors.panelLight;

export const styles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	navbar: {
		backgroundColor: Colors.panel,
		zIndex: 100,
		boxShadow: "none",
	},
	toolbar: {
		minHeight: `${HEADER_HEIGHT}px !important`,
		height: HEADER_HEIGHT,
		paddingLeft: 10,
		paddingRight: 8,
		gap: 18,
		"@media (min-width: 600px)": {
			minHeight: `${HEADER_HEIGHT}px !important`,
		},
	},
	bottomToolbar: {
		minHeight: "56px !important",
		height: 56,
		padding: 0,
		"@media (min-width: 600px)": {
			minHeight: "56px !important",
		},
	},
	burgerWrap: {
		display: "inline-flex",
		marginRight: -18,
		"@media (min-width: 960px)": {
			display: "none",
		},
	},
	logo: {
		height: 22,
		cursor: "pointer",
		flexShrink: 0,
		marginRight: -4,
	},
	brandDivider: {
		width: 2,
		height: 28,
		backgroundColor: HAIRLINE,
		flexShrink: 0,
	},
	brandDividerLogo: {
		width: 2,
		height: 28,
		backgroundColor: HAIRLINE,
		flexShrink: 0,
		"@media (max-width: 699.95px)": {
			display: "none",
		},
	},
	gameLabel: {
		fontSize: 10,
		fontWeight: 600,
		letterSpacing: "0.22em",
		textTransform: "uppercase",
		color: Colors.primaryDarker,
		marginRight: 10,
		fontFamily: "Roboto, sans-serif",
		lineHeight: 1,
	},
	gameName: {
		fontSize: 15,
		fontWeight: 500,
		color: Colors.primary,
		textTransform: "none",
		letterSpacing: "-0.005em",
		fontFamily: "Roboto, sans-serif",
		lineHeight: 1,
		whiteSpace: "nowrap",
	},
	tabsContainer: {
		display: "flex",
		alignItems: "center",
		flex: "1 1 0",
		minWidth: 0,
		"@media (max-width: 999.95px)": {
			display: "none",
		},
	},
	tabNavButton: {
		color: Colors.primaryDark,
		flexShrink: 0,
		padding: 4,
		"&.Mui-disabled": {
			width: 0,
			overflow: "hidden",
			opacity: 0,
			padding: 0,
		},
	},
	gameMenuArea: {
		display: "inline-flex",
		alignItems: "center",
		flexShrink: 0,
		gap: 18,
		"@media (max-width: 699.95px)": {
			display: "none",
		},
	},
	authButtons: {
		marginLeft: "auto",
		display: "inline-flex",
		alignItems: "center",
		gap: 4,
		flexShrink: 0,
		"@media (max-width: 699.95px)": {
			display: "none",
		},
	},
	compactMenuArea: {
		marginLeft: "auto",
		display: "none",
		alignItems: "center",
		flexShrink: 0,
		"@media (max-width: 699.95px)": {
			display: "inline-flex",
		},
	},
	menuSectionHeader: {
		fontFamily: "Roboto, sans-serif",
		fontSize: 10,
		fontWeight: 700,
		letterSpacing: "0.18em",
		textTransform: "uppercase",
		color: Colors.primaryDarker,
		lineHeight: 1.2,
		padding: "6px 16px 2px",
		backgroundColor: Colors.panel,
	},
	compactMenuPaper: {
		color: Colors.primary,
		backgroundColor: Colors.panel,
		border: `1px solid ${Colors.panelLight}`,
		borderRadius: 4,
		marginTop: 6,
		"& .MuiList-padding": {
			paddingTop: 4,
			paddingBottom: 4,
		},
		"& .MuiMenuItem-root": {
			minHeight: "auto",
			paddingTop: 8,
			paddingBottom: 8,
			fontSize: 14,
		},
		"& .MuiDivider-root": {
			marginTop: 4,
			marginBottom: 4,
		},
		"& .Mui-disabled": {
			opacity: 0.6,
		},
	},
	gameMenuItemActive: {
		color: `${Colors.pickstop} !important`,
		fontWeight: 600,
		backgroundColor: `${Colors.panelLight} !important`,
	},
	userIcon: {
		color: Colors.primary,
	},
	bellIcon: {
		color: Colors.primary,
		fontSize: 21,
	},
	bellButton: {
		paddingRight: 3,
	},
	userSep: {
		width: 2,
		height: 28,
		backgroundColor: HAIRLINE,
		margin: "0 6px",
		flexShrink: 0,
	},
	username: {
		fontSize: 14,
		fontWeight: 500,
		color: Colors.primary,
		textTransform: "none",
		letterSpacing: "0.01em",
		fontFamily: "Roboto, sans-serif",
		lineHeight: 1,
	},
	bellDot: {
		backgroundColor: Colors.pickstop,
		minWidth: 8,
		height: 8,
		padding: 0,
		border: `2px solid ${Colors.panel}`,
		boxSizing: "content-box",
	},
	authLink: {
		fontFamily: "Roboto, sans-serif",
		fontSize: 12,
		fontWeight: 600,
		letterSpacing: "0.18em",
		textTransform: "uppercase",
		color: Colors.primaryDark,
		padding: "6px 12px",
		minWidth: 0,
		backgroundColor: "transparent",
		border: "none",
		"&:hover": {
			backgroundColor: "transparent",
			color: Colors.primary,
		},
	},
	authRegister: {
		color: Colors.pickstop,
		"&:hover": {
			color: Colors.pickstop,
			opacity: 0.85,
			backgroundColor: "transparent",
		},
	},
	menu: {
		color: Colors.primary,
		backgroundColor: Colors.panel,
		border: `1px solid ${Colors.panelLight}`,
		borderRadius: 4,
		marginTop: 6,
		"& .MuiDivider-root": {
			"@media (max-width: 699.95px)": {
				marginTop: 4,
				marginBottom: 4,
			},
		},
	},
	notification: {
		fontSize: 14,
		"& b": {
			color: Colors.pickstop,
		},
	},
	bottomBar: {
		backgroundColor: Colors.panel,
		zIndex: 100,
		top: "auto",
		bottom: 0,
	},
	usernameChip: {
		display: "none",
	},
	tabicons: {
		display: "none",
	},
	smallTabIcons: {
		display: "block",
		margin: "0 auto",
		width: 18,
		height: 18,
		fill: "currentColor",
	},
	title: {
		flexGrow: 1,
	},
}));

export const gameMenu = makeStyles((theme) => ({
	root: {
		fontFamily: "Roboto, sans-serif",
		textTransform: "none",
		backgroundColor: "transparent",
		border: "none",
		padding: "6px 8px",
		minWidth: 0,
		minHeight: 0,
		flexShrink: 0,
		"&:hover": {
			backgroundColor: "transparent",
		},
		"&:hover $endIcon": {
			color: Colors.pickstop,
		},
	},
	label: {
		display: "inline-flex",
		alignItems: "center",
		flexWrap: "nowrap",
	},
	endIcon: {
		marginLeft: 6,
		color: Colors.primaryDarker,
		transition: "color 0.2s ease",
	},
}));

export const tabs = makeStyles((theme) => ({
	root: {
		minHeight: HEADER_HEIGHT,
		flex: "1 1 0",
		minWidth: 0,
	},
	flexContainer: {
		gap: 4,
		justifyContent: "flex-start",
	},
	indicator: {
		height: 2.5,
		backgroundColor: Colors.pickstop,
		borderLeft: "none",
		borderRight: "none",
		transition: "all 0.3s cubic-bezier(0.2, 0.8, 0.2, 1)",
	},
	scrollButtons: {
		color: Colors.primaryDark,
		"&.Mui-disabled": {
			width: 0,
			overflow: "hidden",
			opacity: 0,
		},
	},
}));

export const tab = makeStyles((theme) => ({
	root: {
		fontFamily: "Roboto, sans-serif",
		fontWeight: 600,
		fontSize: 12,
		letterSpacing: "0.18em",
		textTransform: "uppercase",
		color: Colors.primaryDark,
		backgroundColor: "transparent",
		minHeight: HEADER_HEIGHT,
		minWidth: "unset",
		padding: "0 18px",
		opacity: 1,
		transition: "color 0.2s ease",
		"& svg": {
			display: "none",
		},
		"& span": {
			color: "inherit",
			whiteSpace: "nowrap",
			lineHeight: 1,
		},
		"&.MuiTab-textColorInherit": {
			color: Colors.primaryDark,
		},
		"&$selected": {
			color: Colors.pickstop,
			backgroundColor: "transparent",
		},
		"&$disabled": {
			color: Colors.primaryDarker,
		},
		"&:hover": {
			color: Colors.primary,
			backgroundColor: "transparent",
		},
	},
	selected: {},
	disabled: {},
	wrapper: {
		flexDirection: "row",
	},
}));

export const bottomTabs = makeStyles((theme) => ({
	indicator: {
		backgroundColor: Colors.pickstop,
		height: 2,
		top: 0,
	},
	root: {
		width: "100%",
	},
}));

export const bottomTab = makeStyles((theme) => ({
	root: {
		fontFamily: "Roboto, sans-serif",
		fontWeight: 600,
		fontSize: 10,
		letterSpacing: "0.12em",
		textTransform: "uppercase",
		color: Colors.primaryDark,
		backgroundColor: "transparent",
		minHeight: 56,
		minWidth: "unset",
		padding: "6px 8px",
		opacity: 1,
		display: "block",
		transition: "color 0.2s ease",
		"& span": {
			color: "inherit",
			whiteSpace: "nowrap",
			lineHeight: 1,
			marginTop: 6,
			display: "block",
		},
		"&.MuiTab-textColorInherit": {
			color: Colors.primaryDark,
		},
		"&$selected": {
			color: Colors.pickstop,
			backgroundColor: "transparent",
		},
		"&:hover": {
			color: Colors.primary,
			backgroundColor: "transparent",
		},
	},
	selected: {},
	disabled: {},
}));
